import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { LogIn } from "lucide-react";
import { useT } from "@/context/LangContext";

export default function Login() {
  const t = useT();
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = loc.state?.from || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin" : next, { replace: true });
    } catch (e) {
      setErr(formatApiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-md card-flat p-10">
        <p className="kicker">{t("auth.login.kicker")}</p>
        <h1 className="font-display text-3xl font-black mt-3">{t("auth.login.title")}</h1>
        <p className="text-[var(--ink-soft)] mt-2 text-sm">{t("auth.login.desc")}</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          {err && <div className="bg-red-50 border border-red-200 text-red-700 p-3 rounded text-sm" data-testid="login-error">{err}</div>}
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("auth.email")} className="input-field" data-testid="login-email" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("auth.password")} className="input-field" data-testid="login-password" />
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">
            {loading ? t("auth.login.loading") : <>{t("auth.login.submit")} <LogIn size={16} /></>}
          </button>
        </form>

        <p className="text-sm text-[var(--ink-soft)] mt-6 text-center">
          {t("auth.login.noAccount")} <Link to="/register" className="font-semibold text-[var(--accent)]" data-testid="link-register">{t("auth.login.createAcc")}</Link>
        </p>
      </div>
    </div>
  );
}
